import React, { useState, useEffect } from 'react';
import { Modal, View, Text, Pressable } from 'react-native';
import AdminInput from '../AdminInput';
import AdminSwitch from '../AdminSwitch';
import { ADMIN_COLORS, ADMIN_FONT } from '../../config/theme/adminColors';

// Modal de criação com TÍTULO OBRIGATÓRIO + opção de exibir/ocultar o título
// para os alunos. Reutilizado na criação de categorias e de módulos (cards).
//
// Motivo: evitar que categorias/módulos sejam publicados com o nome padrão
// ("NOME CATEGORIA"/"Nome do Módulo") e garantir que sempre exista um título
// para busca, filtros e configuração de acesso — mesmo quando o admin prefere
// não exibi-lo aos alunos (visual mais limpo). Ver alerta quando ocultado.
const TitlePromptModal = ({ visible, entityLabel = 'item', onConfirm, onCancel }) => {
  const [value, setValue] = useState('');
  const [hideTitle, setHideTitle] = useState(false);
  const [error, setError] = useState('');
  const isCategory = entityLabel === 'categoria';
  const artigo = isCategory ? 'a categoria' : 'o módulo';

  useEffect(() => {
    if (visible) {
      setValue('');
      setHideTitle(false);
      setError('');
    }
  }, [visible]);

  const confirm = () => {
    const t = (value || '').trim();
    if (!t) {
      setError(`O título d${isCategory ? 'a categoria' : 'o módulo'} é obrigatório.`);
      return;
    }
    onConfirm(t, hideTitle);
  };

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onCancel}>
      <View style={{ flex: 1, backgroundColor: 'rgba(17,24,39,0.45)', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <View style={{ width: '100%', maxWidth: 460, backgroundColor: ADMIN_COLORS.surface, borderRadius: 16, borderWidth: 1, borderColor: ADMIN_COLORS.border, padding: 20 }}>
          <Text style={{ fontFamily: ADMIN_FONT, fontSize: 18, fontWeight: '700', color: ADMIN_COLORS.ink, marginBottom: 4 }}>
            {isCategory ? 'Nova categoria' : 'Novo módulo'}
          </Text>
          <Text style={{ fontFamily: ADMIN_FONT, fontSize: 13, color: ADMIN_COLORS.muted, marginBottom: 16 }}>
            {`Defina um título para identificar ${artigo}.`}
          </Text>

          <Text style={{ fontFamily: ADMIN_FONT, fontSize: 14, fontWeight: '600', color: ADMIN_COLORS.label, marginBottom: 6 }}>
            Título
          </Text>
          <AdminInput
            autoFocus
            placeholder={`Digite o título d${isCategory ? 'a categoria' : 'o módulo'}`}
            value={value}
            onChangeText={(t) => { setValue(t); if (error) setError(''); }}
            onSubmitEditing={confirm}
          />
          {error ? (
            <Text style={{ color: ADMIN_COLORS.danger, fontFamily: ADMIN_FONT, fontSize: 12, marginTop: 6 }}>{error}</Text>
          ) : null}

          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginTop: 18 }}>
            <View style={{ flex: 1 }}>
              <Text style={{ fontFamily: ADMIN_FONT, fontSize: 14, fontWeight: '600', color: ADMIN_COLORS.label }}>
                Exibir título para os alunos
              </Text>
              <Text style={{ fontFamily: ADMIN_FONT, fontSize: 12, color: ADMIN_COLORS.muted, marginTop: 2, lineHeight: 16 }}>
                Desative para um visual mais limpo — o título continua valendo internamente.
              </Text>
            </View>
            <AdminSwitch
              value={!hideTitle}
              onValueChange={(v) => setHideTitle(!v)}
            />
          </View>

          {hideTitle && (
            <View style={{ marginTop: 12, backgroundColor: ADMIN_COLORS.warnBg, borderColor: ADMIN_COLORS.warnBorder, borderWidth: 1, borderRadius: 10, padding: 12 }}>
              <Text style={{ fontFamily: ADMIN_FONT, fontSize: 13, color: ADMIN_COLORS.warnText, lineHeight: 18 }}>
                {`O título ficará invisível para os alunos, mas continua sendo usado na busca, nos filtros e na configuração de acesso. Sem um título claro, fica difícil identificar ${artigo} nessas telas.`}
              </Text>
            </View>
          )}

          <View style={{ flexDirection: 'row', justifyContent: 'flex-end', gap: 12, marginTop: 20 }}>
            <Pressable
              onPress={onCancel}
              style={{ minHeight: 44, borderRadius: 10, paddingHorizontal: 20, alignItems: 'center', justifyContent: 'center', backgroundColor: ADMIN_COLORS.secondaryBg, cursor: 'pointer' }}
            >
              <Text style={{ fontFamily: ADMIN_FONT, fontSize: 14, fontWeight: '600', color: ADMIN_COLORS.secondaryText }}>Cancelar</Text>
            </Pressable>
            <Pressable
              onPress={confirm}
              style={{ minHeight: 44, borderRadius: 10, paddingHorizontal: 20, alignItems: 'center', justifyContent: 'center', backgroundColor: ADMIN_COLORS.teal, cursor: 'pointer' }}
            >
              <Text style={{ fontFamily: ADMIN_FONT, fontSize: 14, fontWeight: '600', color: '#ffffff' }}>Criar</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default TitlePromptModal;
